import { useTranslation } from 'react-i18next';
import { CURRENCIES, Currency } from '../lib/currency';
import { useCurrency } from '../currency/CurrencyContext';

/**
 * MAD · EUR · USD toggle group. Mirrors {@link LanguageSelector} — active
 * currency is brass, the rest are ash. Selection persists via
 * {@link CurrencyProvider} (localStorage 'handcrafted.currency').
 */
export function CurrencySelector() {
  const { t } = useTranslation();
  const { currency, setCurrency } = useCurrency();

  return (
    <div className="flex items-center gap-2" role="group" aria-label={t('currency.label')}>
      <select
        value={currency}
        onChange={(e) => setCurrency(e.target.value as Currency)}
        className="sr-only"
        aria-label={t('currency.label')}
      >
        {CURRENCIES.map((c) => (
          <option key={c} value={c}>
            {t(`currency.codes.${c}`)}
          </option>
        ))}
      </select>
      {CURRENCIES.map((c, i) => (
        <span key={c} className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setCurrency(c)}
            className={`editorial-label transition-colors ${
              currency === c ? 'text-brass' : 'text-ash hover:text-ink'
            }`}
            aria-label={t(`currency.codes.${c}`)}
            aria-pressed={currency === c}
          >
            {c}
          </button>
          {i < CURRENCIES.length - 1 && <span className="text-linen text-xs">·</span>}
        </span>
      ))}
    </div>
  );
}
